import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from '../../components/DropdownMenu'
import { insertRegistrationFormTemplate,fetchRegistrationFormTemplates } from "../../services/registrationFormTemplates";
import SearchSvg from '../../svgs/SearchSvg';

const limit = 20
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo=(str)=>()=>{
        navigate(str)
    }
    const [isloading,setIsloading]=useState(false)
 

    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem/limit)||1
    const [data,setData]=useState([])
    const page =  parseInt(searchParams.get('page'))||1
    const filterName = searchParams.get('name')
    const filterType = searchParams.get('type')||'全部'
    //
    const handleSearchName=(e)=>{setSearchParams({page:1,name:e.target.value})}
    useEffect(() => {
        if(!props.token.isLogin)return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    },[searchParams,props.token])
    async function fetchData(){
        const filter = {}
        if(filterType !== '全部') filter['status'] = filterType==='草稿'?'draft':'published'
 
        if(filterName) filter['name'] = {"$regex": filterName, "$options":'i'}
        const res = await fetchRegistrationFormTemplates(props.token?.token,filter, {limit,skip:limit*(page-1),sort:{order:-1}})
        if(res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count/limit) || 1
        if(page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage=(p)=>()=>{
        if(p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val){
        searchParams.delete(key)
        if(val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    function selectFilter(item,index){
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    //new event
    const [isAddingNewEvent, setIsAddingNewEvent] = useState(false)
    const handleAddEvent=async ()=>{
        if(isAddingNewEvent?.name?.length<3){
            alert('報名表名稱長度需大於3')
            return
        }
        setIsloading(true)
        let json ={
            name:isAddingNewEvent?.name,
            status:'draft',
            questions:[],
            order:1
        }
        let result = await insertRegistrationFormTemplate(props.token.token,json)
        if(result.errno){
            alert(result.message||'新增失敗')
        }else{
            alert('新增報名表成功')
            setIsAddingNewEvent(false)
            handleParamChange('page', 1)
        }
        setIsloading(false)
    }
    return(
        <div className="h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden pb-[16px]" style={{}}>
            <div className="w-full flex flex-row gap-[16px] items-center justify-between relative p-[16px]">
                <div className="gap-[8px] flex flex-row items-center justify-start z-[2] px-[12px] py-[2px] border-[1px] border-[#6E604C] rounded-[99px]">
                    <SearchSvg />
                    <input onChange={handleSearchName} placeholder="按報名表名稱搜尋" className="bg-[transparent] w-[130px] border-none" />
                </div>
                <div className="z-[2] flex flex-row gap-[16px]">
                    <div className="text-[#6E604C]">Filter By </div>
                    <DropdownMenu value={filterType} select={selectFilter} options={['全部', '草稿', '已公開']} />
                </div>
                <div className="flex flex-row flex-1 justify-end gap-[16px] z-[2]">
                    <div onClick={()=>{setIsAddingNewEvent({})}} className="cursor-pointer hover:opacity-80">
                        <div className="bg-[#0F737E] text-[white] rounded-[99px] text-[14px] font-[700] p-[8px] px-[16px] flex flex-row items-center justify-center">
                            新增報名表
                        </div>
                    </div>
                </div>
                <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{background:'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)'}}/>
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px] justify-start items-stretch px-[8px]" style={{overflow:'auto'}}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center min-w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{borderBottom:'2px solid #6E604C'}}>
                    <div className="flex-[2] min-w-[200px]">報名表名稱</div>
                    <div className="flex-[1] min-w-[50px]">狀態</div>
                    <div className="flex-[2] min-w-[100px]">創建時間</div>
                    <div className="flex-[2] min-w-[100px]">更新時間</div>
                    <div className="flex-[1] min-w-[70px]">顯示順序</div>
                    <div className="min-w-[300px] w-[300px]">操作</div>
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item,index)=>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center min-w-full text-[12px] text-[black] font-[400] py-[8px]" style={{borderBottom:'.5px solid #fff'}}>
                            <div className="flex-[2] min-w-[200px]">{item?.name||''}</div>        
                            <div className="flex-[1] min-w-[50px]">{item?.status==='published'?'已公開':'草稿'}</div>
                            <div className="flex-[2] min-w-[100px]">{new Date(item?.createDate).toLocaleString()}</div>     
                            <div className="flex-[2] min-w-[100px]">{new Date(item?.modifyDate).toLocaleString()}</div>
                            <div className="flex-[1] min-w-[70px]">{item?.order||'-'}</div>
                            <div className="min-w-[300px] w-[300px] flex flex-row items-start justify-start">
                                <div onClick={navigateTo(`/cms/registration-forms/${item?._id}`)} className="w-[90px] text-center cursor-pointer border-[#6E604C]  border-[1px] text-[#6E604C] p-[2px] rounded-[4px] bg-[#6E604C30]">報名數據</div>
                            </div>
                        </div>
                    )}
                </div>

            </div>

         
            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage}/>
            
            {isAddingNewEvent&&<div className="fixed top-0 left-0 w-full h-full bg-[#00000099] flex flex-col items-center justify-center z-[1]">
                <div className="max-w-[90%] max-h-[90%] min-w-[500px] bg-[#fff] rounded-[8px] flex flex-col items-center justify-start p-[16px]">
                    <div className="font-bold text-[24px] w-full text-center">新報名表</div>
                    <div className="flex flex-col items-start justify-start w-full mt-[16px] w-[370px] max-w-[100%]">
                        <div className='font-[700]'>報名表名稱</div>
                        <input value={isAddingNewEvent?.name||''} onChange={(e) => { setIsAddingNewEvent({ ...data, name: e.target.value }) }} placeholder='報名表名稱' className='w-full rounded-[7px] px-[8px] py-[4px] font-[400]' style={{border:'.5px solid black'}}/>
                    </div>
                    <div className="flex flex-col items-center justify-center w-full mt-[64px] gap-[16px]">
                        <div onClick={handleAddEvent} className="cursor-pointer text-[white] justify-center bg-[#0F737E] w-full rounded-[99px] text-[14px] font-[700] p-[8px] hover:opacity-80 items-center flex flex-row">
                            添加
                        </div>
                        <div onClick={()=>{setIsAddingNewEvent(false)}} className="cursor-pointer justify-center text-[#0F737E] w-full rounded-[99px] text-[14px] font-[700] p-[8px] rounded-[4px] bg-[#eee] hover:opacity-80 items-center flex flex-row">
                            取消
                        </div>
                    </div>
                </div>
            </div>}
            {isloading&&<LoadingPage/>}
        </div>
    )
}


export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Page)
